var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    stroke: "#fff",
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .arrow-left-icon{fill:#fff;opacity:0;}.arrow-left-icon-b{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "arrow-left-icon",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "arrow-left-icon-b",
    d: "M6.807,12.087,0,6,6.807,0",
    transform: "translate(4.5 1.863)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.514446da2c23a2e23bc247c037f841aa.svg";
export { ForwardRef as ReactComponent };